import { RootStore } from '/src/context/stores/rootStore';

export class BaseStore {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
}
